import IntlPhoneInput from './IntlPhoneInput';

export { default as IntlPhoneInputLoading } from './IntlPhoneInputLoading';
export default IntlPhoneInput;
